// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media(max-width: 1024px){
    .TripStays_swipe-arrow-container__UhNfI{
        width: 8vw;
        height: 8vw;
        margin: auto;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/SingleTripPage/mobile/TripStays/TripStays.module.css"],"names":[],"mappings":"AAAA;IACI;QACI,UAAU;QACV,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":["@media(max-width: 1024px){\n    .swipe-arrow-container{\n        width: 8vw;\n        height: 8vw;\n        margin: auto;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"swipe-arrow-container": `TripStays_swipe-arrow-container__UhNfI`
};
export default ___CSS_LOADER_EXPORT___;
